(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* Galerie : défilement natif (swipe mobile) + vignettes + flèches */
  $$('[data-gallery]').forEach(g => {
    const track = $('[data-track]', g);
    const slides = $$('[data-slide]', g);
    const thumbs = $$('[data-thumb]', g);
    const go = i => track.scrollTo({ left: Math.max(0, Math.min(i, slides.length - 1)) * track.clientWidth, behavior: 'smooth' });
    const idx = () => Math.round(track.scrollLeft / track.clientWidth);
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    $('[data-prev]', g)?.addEventListener('click', () => go(idx() - 1));
    $('[data-next]', g)?.addEventListener('click', () => go(idx() + 1));
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') go(idx() + 1);
      if (e.key === 'ArrowLeft') go(idx() - 1);
    });
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => thumbs.forEach((t, i) => t.setAttribute('aria-current', i === idx())));
    }, { passive: true });
  });

  /* Vidéos : lecture automatique quand elles sont visibles (muettes), pause sinon.
     Corrigé pour mobile : seuil de visibilité bas (vidéos verticales plus hautes que l'écran),
     attribut muet forcé (iOS), reprise au premier toucher, contrôles si la lecture auto est bloquée. */
  const vids = [...document.querySelectorAll('.gallery__video, [data-autovideo]')];
  if (vids.length) {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const tryPlay = v => {
      v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      const p = v.play();
      if (p && p.catch) p.catch(() => { v.dataset.blocked = '1'; });
    };
    vids.forEach(v => {
      v.muted = true; v.defaultMuted = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
      v.preload = 'auto';
      if (reduce) v.setAttribute('controls', '');
      v.addEventListener('click', () => { if (v.paused) { delete v.dataset.paused; tryPlay(v); } });
    });
    const visible = e => e.isIntersecting && (e.intersectionRatio >= 0.25 || e.intersectionRect.height >= window.innerHeight * 0.4);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(e => {
        const v = e.target;
        if (visible(e) && !v.dataset.paused && !reduce) tryPlay(v);
        else v.pause();
      }), { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
      vids.forEach(v => io.observe(v));
    } else if (!reduce) {
      vids.forEach(tryPlay);
    }
    /* Si le navigateur (économie d'énergie iOS…) a bloqué la lecture auto, on relance au premier toucher */
    const unlock = () => vids.forEach(v => {
      const r = v.getBoundingClientRect();
      if (v.paused && !v.dataset.paused && r.bottom > 0 && r.top < window.innerHeight) tryPlay(v);
    });
    ['touchstart', 'click', 'scroll'].forEach(ev => window.addEventListener(ev, unlock, { once: true, passive: true }));
  }
  document.querySelectorAll('[data-video-toggle]').forEach(b => b.addEventListener('click', () => {
    const v = b.parentElement.querySelector('video');
    if (!v) return;
    if (v.paused) { delete v.dataset.paused; v.muted = true; v.play().catch(() => {}); b.textContent = '❚❚'; }
    else { v.dataset.paused = '1'; v.pause(); b.textContent = '▶'; }
  }));

  /* Sélecteur de longueur d'onde : met à jour la légende */
  $$('[data-waves]').forEach(w => {
    const cap = $('[data-wave-cap]', w);
    const btns = $$('.wave', w);
    const hero = w.closest('.hero');
    const info = $('[data-wave-info]', w), ti = $('[data-wave-title]', w), tx = $('[data-wave-text]', w);
    btns.forEach(b => b.addEventListener('click', () => {
      w.classList.add('is-touched');
      btns.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      if (cap) cap.textContent = b.dataset.label || '';
      if (info) {
        if (ti) ti.textContent = b.dataset.title || '';
        if (tx) tx.textContent = b.dataset.text || '';
        info.hidden = !(b.dataset.title || b.dataset.text);
        if (b.dataset.color) info.style.setProperty('--wave', b.dataset.color);
      }
      /* le halo lumineux autour des photos prend la couleur choisie */
      if (hero && b.dataset.color) hero.style.setProperty('--glow', b.dataset.color);
    }));
  });

  /* Formules : met à jour prix, prix barré, badge et boutons */
  const form = $('#hero-form');
  if (form) {
    form.addEventListener('change', e => {
      if (e.target.name !== 'id') return;
      const d = e.target.dataset;
      $$('[data-live-price]').forEach(el => { el.textContent = d.price; });
      $$('[data-live-compare]').forEach(el => { el.textContent = d.compare || ''; el.hidden = !d.compare; });
      $$('[data-live-save]').forEach(el => { el.textContent = d.save || ''; el.hidden = !d.save; });
      $$('[data-live-badge]').forEach(el => { el.textContent = d.pct || ''; el.hidden = !d.pct; });
    });
  }

  /* Frise de livraison : dates estimées à partir d'aujourd'hui */
  $$('[data-ship]').forEach(el => {
    const n = k => Number(el.dataset[k]);
    const DAY = 864e5, now = Date.now();
    const full = d => d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
    const short = d => d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
    const range = (a, b) => {
      if (!(a >= 0) || !(b >= a)) return '';
      const d1 = new Date(now + a * DAY), d2 = new Date(now + b * DAY);
      if (a === b) return full(d1);
      return d1.getMonth() === d2.getMonth() ? d1.getDate() + ' – ' + full(d2) : short(d1) + ' – ' + short(d2);
    };
    const set = (k, txt) => { const t = $('[data-ship-date="' + k + '"]', el); if (t && txt) t.textContent = txt; };
    set('order', full(new Date(now)));
    set('ship', range(n('s1'), n('s2')));
    set('deliver', range(n('d1'), n('d2')));
  });

  /* Bouton d'achat collant (mobile) */
  const bar = $('[data-sticky]'), anchor = $('[data-buy-anchor]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      bar.classList.toggle('is-on', !e.isIntersecting);
    }).observe(anchor);
  }

  /* FAQ accordéon */
  $$('[data-faq] .faq__q').forEach(btn => btn.addEventListener('click', () => {
    const open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    btn.closest('.faq__item').classList.toggle('is-open', !open);
  }));

  /* Comparateur avant / après : glisser (souris, tactile, clavier) + petit mouvement d'invitation */
  $$('[data-ba]').forEach(ba => {
    const input = $('input', ba);
    const set = v => { input.value = v; ba.style.setProperty('--pos', v + '%'); };
    let nudged = false, raf;
    const stop = () => { nudged = true; ba.classList.add('is-touched'); cancelAnimationFrame(raf); };
    input.addEventListener('input', () => { stop(); set(input.value); });
    input.addEventListener('keydown', stop);
    input.addEventListener('pointerdown', () => { stop(); ba.classList.add('is-drag'); });
    addEventListener('pointerup', () => ba.classList.remove('is-drag'));
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting || nudged) return;
        io.disconnect();
        const t0 = performance.now();
        const step = t => {
          if (nudged) return;
          const k = (t - t0) / 1800;
          if (k >= 1) { set(50); return; }
          set(50 + Math.sin(k * Math.PI * 2) * 14 * (1 - k));
          raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
      }, { threshold: 0.6 });
      io.observe(ba);
    }
  });

  /* Compte à rebours : uniquement avec une vraie date de fin */
  $$('[data-countdown]').forEach(el => {
    const wrap = el.closest('[data-countdown-wrap]') || el;
    const end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return;
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      const s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { wrap.hidden = true; return false; }
      const d = Math.floor(s / 86400);
      el.textContent = (d ? d + 'j ' : '') + pad(Math.floor(s % 86400 / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      wrap.hidden = false;
      return true;
    };
    if (tick()) { const t = setInterval(() => { if (!tick()) clearInterval(t); }, 1000); }
  });
  /* Apparition progressive des blocs au défilement */
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initReveal = () => {
    const els = $$('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduced || (window.Shopify && Shopify.designMode)) {
      els.forEach(el => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(entries => entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target;
      el.classList.add('is-in');
      io.unobserve(el);
      setTimeout(() => { el.style.transitionDelay = ''; }, 1400);
    }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(el => {
      const i = [...el.parentElement.children].filter(c => c.hasAttribute('data-reveal')).indexOf(el);
      el.style.transitionDelay = Math.min(i, 5) * 90 + 'ms';
      io.observe(el);
    });
  };
  initReveal();
  document.addEventListener('shopify:section:load', initReveal);

  /* Chiffres qui montent jusqu'à leur valeur */
  $$('[data-count]').forEach(el => {
    const m = el.textContent.trim().match(/^([^\d]*)(\d+)(.*)$/);
    if (!m || reduced || !('IntersectionObserver' in window)) return;
    const [, pre, num, post] = m, target = +num;
    el.textContent = pre + '0' + post;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      const t0 = performance.now();
      const step = t => {
        const k = Math.min((t - t0) / 1200, 1);
        el.textContent = pre + Math.round(target * (1 - Math.pow(1 - k, 3))) + post;
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }, { threshold: 0.6 });
    io.observe(el);
  });

  /* En-tête : ombre légère après défilement */
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', scrollY > 8);
    onScroll();
    addEventListener('scroll', onScroll, { passive: true });
  }
  /* Carrousel d'avis : flèches, barre de progression, défilement auto (pause au survol / toucher) */
  $$('[data-carousel]').forEach(c => {
    const track = $('[data-ctrack]', c), bar = $('[data-cbar]', c);
    const prev = $('[data-cprev]', c), next = $('[data-cnext]', c);
    const max = () => track.scrollWidth - track.clientWidth;
    const step = () => {
      const first = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 20;
      return first ? first.getBoundingClientRect().width + gap : track.clientWidth;
    };
    const update = () => {
      const sw = track.scrollWidth || 1;
      bar.style.width = Math.min(100, track.clientWidth / sw * 100) + '%';
      bar.style.marginLeft = (track.scrollLeft / sw * 100) + '%';
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max() - 4;
    };
    const go = d => track.scrollBy({ left: d * step(), behavior: reduced ? 'auto' : 'smooth' });
    let timer = null, hold = false, resume;
    const tick = () => {
      if (hold || document.hidden) return;
      if (track.scrollLeft >= max() - 4) track.scrollTo({ left: 0, behavior: reduced ? 'auto' : 'smooth' });
      else go(1);
    };
    const start = () => { if (c.hasAttribute('data-autoplay') && !reduced && !timer) timer = setInterval(tick, 5000); };
    const stop = () => { clearInterval(timer); timer = null; };
    const pause = () => { stop(); clearTimeout(resume); resume = setTimeout(start, 12000); };
    prev?.addEventListener('click', () => { pause(); go(-1); });
    next?.addEventListener('click', () => { pause(); go(1); });
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); pause(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); pause(); go(-1); }
    });
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    addEventListener('resize', update);
    c.addEventListener('pointerenter', () => { hold = true; });
    c.addEventListener('pointerleave', () => { hold = false; });
    c.addEventListener('focusin', () => { hold = true; });
    c.addEventListener('focusout', () => { hold = false; });
    track.addEventListener('touchstart', pause, { passive: true });
    $$('[data-review]', c).forEach(r => {
      const t = $('[data-rtxt]', r), m = $('[data-rmore]', r);
      if (!t || !m) return;
      const check = () => { if (!t.classList.contains('is-open')) m.hidden = !(t.scrollHeight > t.clientHeight + 2); };
      check(); addEventListener('resize', check);
      m.addEventListener('click', () => { const o = t.classList.toggle('is-open'); m.textContent = o ? 'Réduire' : 'Lire la suite'; m.hidden = false; pause(); });
    });
    update();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => { e.isIntersecting ? start() : stop(); }, { threshold: 0.3 }).observe(c);
    }
  });
})();
